import styled from 'styled-components';

export const Container = styled.div`
  overflow: auto;
`;

export const GroupingContainer = styled.div`
  container-name: goal-list;
  container-type: inline-size;
  padding: ${({ theme }) => `0 0 ${theme.spacing(6)} 0`};
`;
